/**
 * Strip locale prefix from pathname (e.g. /en/orders → /orders).
 * Handles 2-letter locale codes at the start of the path.
 */
export function stripLocale(path: string): string {
  return path.replace(/^\/[a-z]{2}(?=\/|$)/, '');
}

/**
 * Check if a navigation href matches the current pathname.
 * Matches exact path or any sub-path (e.g. /orders matches /orders/123).
 * Handles locale-prefixed paths (e.g. /en/orders matches href /orders).
 */
export function isPathActive(href: string | undefined, pathname: string, exactMatch = false): boolean {
  if (!href) return false;
  const normalizedPath = stripLocale(pathname);
  if (exactMatch) return normalizedPath === href;
  return normalizedPath === href || normalizedPath.startsWith(href + '/');
}
